import CalabriLogo from '@/assets/branding/calabri/CalabriHealth.png';

export default {
  name: 'Calabri Health',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CalabriLogo,
  colors: {
    // Brand colors
    brand_primary: '#235821',
    brand_primary_hover: '#173116', // −10 L, −8 S
    brand_primary_highlight: '#3DB639', // +23 L, +7 S
    brand_primary_mid: '#2D772A', // +8 L,  +2 S
    brand_primary_dark: '#000000', // −25 L, −3 S (clamped)
    brand_secondary: '#0F1D0F', // hue +4°, −15 L, −13 S
  },
};
